export enum ModifyQuoteInfomationPageFromType {
  NORMAL = 'normal',
  MODIFY = 'modify-info',
  MODIFY_CONTINUE = 'modify-step-continue',
}
